/* =============================================================================
   DiSEGNO Builder — config loader
   -----------------------------------------------------------------------------
   Parses the <script type="application/json" data-disegno-config> block that
   snippets/disegno-builder-config.liquid renders into window.DisegnoConfig.
   MUST load before every other disegno.*.js. Safe to run twice (idempotent).
   If the JSON is malformed it logs and falls back to a minimal shape so the
   builder still boots.
   ========================================================================== */
(function (root, doc) {
  'use strict';
  var Disegno = (root.Disegno = root.Disegno || {});

  function parse() {
    if (root.DisegnoConfig && root.DisegnoConfig.__parsed) return root.DisegnoConfig;
    var node = doc.querySelector('[data-disegno-config]');
    var cfg = {};
    if (node) {
      try {
        cfg = JSON.parse(node.textContent || node.innerText || '{}');
      } catch (e) {
        try { console.error('[DiSEGNO] config JSON parse failed:', e); } catch (e2) {}
        cfg = {};
      }
    }
    // minimal-shape guarantees
    cfg.features = cfg.features || { jewelry_types: ['bracelet', 'necklace'], default_jewelry_type: 'bracelet', show_curated: true };
    cfg.copy = cfg.copy || {};
    cfg.analytics = cfg.analytics || { enabled: true, destinations: {} };
    cfg.catalog = cfg.catalog || { categories: [], starters: [], starter_variant_ids: {} };
    cfg.curated = cfg.curated || [];
    cfg.cart = cfg.cart || { mode: 'lines' };
    cfg.saved = cfg.saved || { driver: 'local', proxyBase: '/apps/disegno' };
    cfg.shop = cfg.shop || {};
    cfg.geometry = cfg.geometry || {};
    cfg.__parsed = true;
    root.DisegnoConfig = cfg;
    try { root.dispatchEvent(new CustomEvent('disegno:configready', { detail: cfg })); } catch (e) {}
    return cfg;
  }

  Disegno.Config = { parse: parse, get: function () { return parse(); } };

  // parse immediately (the JSON block precedes this script in the section)
  parse();
})(typeof window !== 'undefined' ? window : this, typeof document !== 'undefined' ? document : { querySelector: function () { return null; } });
